import { combineReducers } from 'redux';

import type { MayBe } from 'modules/global/typing/common/common';

import isVisible from './isVisible';
import selectedId from './selectedId';

export type AuditModelUIModalUnpublishReducer = {
  isVisible: boolean;
  selectedId: MayBe<string>;
};

export default combineReducers({
  isVisible,
  selectedId,
});
